import { AdminRoutes } from "@/data/enums/router";

export default [
  {
    path: "clients/bulk-operations",
    component: () => import("@/views/admin/clients/bulkOperations/index.vue"),
    props: {
      routes: require("./menu").bulkOperationsTabigation
    },
    meta: {
      auth: ["list_bulk_actions"],
      requiresBrand: true
    },
    children: [
      {
        path: "",
        redirect: { name: AdminRoutes.CLIENT_TICKET_BULK_OPERATIONS }
      },
      {
        path: "ticket-operations",
        name: AdminRoutes.CLIENT_TICKET_BULK_OPERATIONS,
        component: () =>
          import(
            "@/views/admin/clients/bulkOperations/ticketOperations/index.vue"
          ),
        meta: {
          auth: ["list_bulk_actions"],
          requiresBrand: true
        }
      }
    ]
  }
];
